import {
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  StackDivider,
  Spinner,
  ModalFooter,
} from "@chakra-ui/react"
import React, { useEffect, useState } from "react"
import { AiOutlineCloseCircle } from "react-icons/ai"
import { baseURL } from "../../../../services/api"
import { HeaderModal } from "./HeaderModal"

const ModalContabilidade = ({ onClose, isOpen, dadosModal, numeroNota, dadosContabilidade, idRemessa }) => {
  const [loading, setLoading] = useState(false)
  const [verifyLength, setVerifyLength] = useState(0)

  const [codProd, setCodProd] = useState([])
  const [numNota, setNumNota] = useState([])
  const [sequencia, setSequencia] = useState([])

  function handleSequencia(value) {
    setSequencia((prev) => [...prev, value])
  }

  function handleCodProd(value) {
    setCodProd((prev) => [...prev, value])
  }

  const dadosFat = dadosContabilidade.cnpj === dadosContabilidade.cnpj_2 ? false : true

  async function sendForm() {
    const verification = dadosFat ? dadosModal.length * 2 : dadosModal.length

    const params = {
      sequencia: sequencia,
      cod_prod: codProd,
      numero_nota: numeroNota,
    }

    setSequencia([])
    setCodProd([])

    if (verification !== verifyLength) {
      alert("Preencha todos os campos")
      return
    }
    setLoading(true)

    const response = await baseURL.post("/pedido/envia-email-icms", params)

    setTimeout(() => {
      setLoading(false)
      onClose()
      setVerifyLength(0)
    }, 2000)
  }

  useEffect(() => {
    setLoading(true)
    const timer = setTimeout(() => {
      setLoading(false)
      clearTimeout(timer)
    }, 6000)
  }, [isOpen])

  return (
    <Modal
      size="xxl"
      motionPreset="slideInBottom"
      onClose={onClose}
      isOpen={isOpen}
      isCentered
      h="full"
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent h="full">
        <ModalHeader bgColor="#3a7993">
          <Text color="white" textAlign="center">
            <strong>ST PEDIDO</strong>
          </Text>
        </ModalHeader>
        <ModalCloseButton
          mt="10px"
          color="white"
          justifyContent="space-around"
          boxShadow="none !important"
          w="80px"
          onClick={() => setVerifyLength(0)}
        >
          <Text fontSize="11.5px" letterSpacing="0.5px">
            <strong>FECHAR</strong>
          </Text>
          <Icon w={4} h={4} mb="0.5px" as={AiOutlineCloseCircle} />
        </ModalCloseButton>
        <ModalBody>
          <HeaderModal
            numNota={numNota}
            dadosContabilidade={dadosContabilidade}
            dadosModal={dadosModal}
            label="DADOS DO FATURAMENTO"
            loading={loading}
            idRemessa={idRemessa}
            isRemesa={false}
            setCodProd={setCodProd}
            setVerifyLength={setVerifyLength}
            handleSequencia={handleSequencia}
            handleCodProd={handleCodProd}
          />
          <StackDivider borderColor="gray.200" w="100%" py="3rem" />
          {!!dadosFat && (
            <HeaderModal
              numNota={numNota}
              isRemessa
              dadosContabilidade={dadosContabilidade}
              dadosModal={dadosModal}
              label="DADOS DA ENTREGA"
              loading={loading}
              idRemessa={idRemessa}
              dadosFat={dadosFat}
              setCodProd={setCodProd}
              codProd={codProd}
              setSequencia={setSequencia}
              setVerifyLength={setVerifyLength}
              handleSequencia={handleSequencia}
              handleCodProd={handleCodProd}
            />
          )}
        </ModalBody>

        <ModalFooter justifyContent="center" alignItems="center" h="100px">
          <Button
            onClick={sendForm}
            bgColor="#5292a2"
            _hover={{ bgColor: "#3a7993" }}
            color="white"
            variant="solid"
            disabled={loading}
          >
            {loading ? (
              <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="md" />
            ) : (
              <Text fontSize="11.5px" letterSpacing="0.5px">
                <strong>ENVIAR</strong>
              </Text>
            )}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ModalContabilidade
